import { withPrefix } from 'gatsby';
import React, { Component } from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import { off } from '../../config/SiteConfig';
import getPPPData from '../../utils/getPPPData';
import log from '../../utils/log';
import Btn from '../Basic/Btn';
import Container from '../Basic/Container';
import Sold from '../Basic/Sold';
import EFire from '../Emoji/EFire';

export default class Bar extends Component {
	constructor(props) {
		super(props);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.state = { hidden: true, country: false };
	}

	async componentDidMount() {
		// Get PPP data.
		const pppData = await getPPPData();
		this.props.log && log('pppData', pppData);

		// Show the bar if no off.
		pppData.discount === 0 && this.setState({ hidden: false, country: pppData.country });
	}

	render() {
		const { country, hidden } = this.state;

		if (hidden) {
			return null;
		}
		return (
			<Wrap className="topBar">
				<Container>
					<Alert>
						<Text>
							Join <Sold />+ developers already learning 200+ VSCode tips & tricks.
						</Text>
						<Btn href="#signup">
							<span>
								<EFire width="18" heign="18" />
								<Sold />+ Already sold!
							</span>
							{country && (
								<Flag src={withPrefix(`flags/${country.toLowerCase()}.svg`)} alt={country} />
							)}{' '}
							{off}% DISCOUNT ↓
						</Btn>
					</Alert>
				</Container>
			</Wrap>
		);
	}
}

// Implement. https://stackoverflow.com/a/15800696/950111
// var topBar = document.querySelector("topBar");
// var onScroll = function () {
// 	var y = window.scrollY;
// 	if (y >= 800) {
// 		topBar.className = "bottomMenu show"
// 	} else {
// 		topBar.className = "bottomMenu hide"
// 	}
// };

// window.addEventListener("scroll", onScroll);

const Wrap = styled.div`
	z-index: 226;
	display: flex;
	align-items: center;
	justify-content: space-between;
	overflow: hidden;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	transform: translate3d(0, -300%, 0);
	transform: translate3d(0, 0, 0) !important;
	padding: ${props => props.theme.vr / 2}rem 0;
	background-color: ${props => props.theme.c2};
	color: ${props => props.theme.w};

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.05);
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
	}

	${rmq('720')} {
		padding: ${props => props.theme.vr / 2}rem;
	}
	${rmq('ms')} {
		display: none;
	}
`;

const Alert = styled.div`
	/* display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-flex: 1;
	-ms-flex: 1 1 auto;
	flex: 1 1 auto;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center; */

	display: table;
	width: 100%;
	vertical-align: middle;
	table-layout: fixed;

	div {
		display: table-cell;
		width: 25%;
		vertical-align: middle;

		${rmq('735')} {
			width: 50%;
		}
		${rmq('ml')} {
			width: 100%;
		}
	}

	a {
		padding: ${props => props.theme.vr / 3}rem ${props => props.theme.vr / 2}rem;
		margin: 0 0 0 ${props => props.theme.vr / 3}rem;
		font-weight: 400;
		font-size: ${props => props.theme.vr * 0.9}rem;

		${rmq('ml')} {
			margin: 0 auto;
			font-size: ${props => props.theme.vr * 0.7}rem;
		}

		span {
			display: none;
			${rmq('ml')} {
				display: inline-block;
				margin-right: ${props => props.theme.vr / 3}rem;
			}
		}
	}

	& > div {
		${rmq('700')} {
			display: table;
			width: 100%;
		}
	}
`;

const Text = styled.p`
	/* display: flex;
	align-items: center; */
	display: table-cell;
	width: 75%;
	vertical-align: middle;

	margin: 0;

	${rmq('735')} {
		font-size: 1.5rem;
		width: 50%;
	}
	${rmq('520')} {
		font-size: 1.3rem;
	}
	${rmq('ml')} {
		display: none;
	}
`;

const Flag = styled.img`
	max-width: ${props => props.theme.vr * 1.1}rem;
	margin: 0 ${props => props.theme.vr * 0.3}rem 0 0;
`;
